import React from 'react';
import { Theme } from '../../Enums/Theme.enum';
import LinkButton from './LinkButton';
import styles from './Buttons.module.scss';
import { Position } from '../../Modules/Base/Enums/Position.enum';

interface Props {
	onClick?: () => void;
	title: string;
	icon: string;
	iconPosition: Position;
	href?: string;
}

const LinkButtonWithIcon: React.FC<Props> = ({
	onClick,
	title,
	icon,
	iconPosition,
	href,
}) => {
	return (
		<div className={styles.attachmentButton}>
			{iconPosition === Position.LEFT && (
				<img className={styles.icon} src={icon} />
			)}
			<LinkButton
				onClick={onClick}
				title={title}
				theme={Theme.BLUE}
				href={href}
			/>
			{iconPosition === Position.RIGHT && (
				<img className={styles.icon} src={icon} />
			)}
		</div>
	);
};

export default LinkButtonWithIcon;
